import React, { memo } from 'react';
import PropTypes from 'prop-types';

const SocialMediaIcons = memo(({ icons, isMini = false }) => {
  return (
    <ul className="list-none flex space-x-4">
      {icons.map((icon, index) => (
        <li key={index} className="transform hover:scale-110 transition-transform duration-200">
          <a 
            href={icon.link} 
            target="_blank" 
            rel="noopener noreferrer"
            className="hover:opacity-80 transition-opacity"
          >
            <img
              src={icon.img}
              alt={icon.alt}
              className={`${isMini ? "w-[15px] h-[15px]" : "w-[30px] h-[30px]"} filter hover:brightness-110`}
            />
          </a>
        </li>
      ))}
    </ul>
  );
});

SocialMediaIcons.propTypes = {
  icons: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string.isRequired,
      img: PropTypes.string.isRequired,
      alt: PropTypes.string.isRequired,
    })
  ).isRequired,
  isMini: PropTypes.bool,
};

export default SocialMediaIcons; 